module.exports = __webpack_public_path__ + "static/media/service_img3.e4f4b0a4.png";